// animation
var animationBlocks = [].slice.call(document.querySelectorAll('.animation-block'));

// check for active animation blocks on scrolling


window.addEventListener('scroll', function () {
    animationBlocks.forEach(function (block) {
        if (isInViewport(block)) {
            animateMultipleEl(block);
        }
    });
}, false);

function animateMultipleEl(elem) {
    var childsArr = [].slice.call(elem.querySelectorAll('.animate-child'));
    var count = 0;
    childsArr[count].classList.add('active');
    count++;
    var spacer = setInterval(function () {
        if (count < childsArr.length) {
            if (!childsArr[count].classList.contains('active')) {
                childsArr[count].classList.add('active');
                count++;
            } else {
                count++;
            }
        } else {
            clearInterval(spacer);
        }
    }, 400)
}

// custom is in View function
function isInViewport(element) {
    var rect = element.getBoundingClientRect();
    var viewPort = window.innerHeight;
    var viewPortWidth = window.innerWidth;
    var isVisibleTop = (rect.top / viewPort) * 100;
    var isVisibleBottom = (rect.bottom / viewPort) * 100;
    var isInView = false;

    if (viewPortWidth > 859) {
        if (rect.top >= 0 && rect.bottom <= viewPort) {
            isInView = true;
            return isInView;
        } else if (isVisibleTop <= 70 && rect.bottom > viewPort) {
            isInView = true;
            return isInView;
        } else if (isVisibleBottom >= 30 && rect.top <= 0) {
            isInView = true;
            return isInView;
        } else {
            return isInView;
        }
    } else {
        if (rect.top >= 0 && rect.bottom <= viewPort) {
            isInView = true;
            return isInView;
        } else if (isVisibleTop <= 90 && rect.bottom > viewPort) {
            isInView = true;
            return isInView;
        } else if (isVisibleBottom >= 10 && rect.top <= 0) {
            isInView = true;
            return isInView;
        } else {
            return isInView;
        }
    }


}

// gets closest matching element up the DOM tree
var getClosest = function (elem, selector) {

    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function (s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {
                }
                return i > -1;
            };
    }

    // Get closest match
    for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.matches(selector)) return elem;
    }

    return null;

};

// invoke secondary navigation
document.addEventListener('DOMContentLoaded', function () {

    // check for active animation blocks active on load
    animationBlocks.forEach(function (block) {
        if (isInViewport(block)) {
            animateMultipleEl(block);
        }
    }, false);

    // seconday navigation
    if (typeof SNav === 'function' && document.getElementById('c-snav')) {
        new SNav(
            document.getElementById('c-snav')
        );
    }
});